// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileNavigation_MobileNavigation__Pokql {
  display: none;
}

@media (max-width: 1024px) {
  .MobileNavigation_MobileNavigation__Pokql {
    display: block;
  }
  .MobileNavigation_MobileNavigation__Pokql ul {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header/NavBar/MobileNavigation/MobileNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":[".MobileNavigation {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .MobileNavigation {\n    display: block;\n  }\n  .MobileNavigation ul {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MobileNavigation": `MobileNavigation_MobileNavigation__Pokql`
};
export default ___CSS_LOADER_EXPORT___;
